module.exports = __webpack_public_path__ + "img/robin-min.3a3277fb.png";